export default __webpack_public_path__ + "static/media/fats.813ce3b9.jpg";